import { IStudyNoteControlsResolver } from './IStudyNoteControlsResolver';
import { Container, RootContainer, RepeatableContainer, RepeatableSection } from './builderComponents/containers';
import { FormDividingLine, ImageBlock, TextBlock } from './builderComponents/content';
import {
  FormCheckboxGroupInput,
  FormDateInput,
  FormDateRangeInput,
  FormDropDownInput,
  FormMultipleDropdownInput,
  FormMultipleTextInput,
  FormNumberInput,
  FormRadioGroupInput,
  FormSliderInput,
  FormTagInput,
  FormTextInput,
  FormTimeInput,
} from './builderComponents/inputs';
import { FormFileInput } from './builderComponents/inputs/formFileInput';

export const studyNoteBuilderControlsResolver: IStudyNoteControlsResolver = {
  // Containers
  RootContainer: RootContainer,
  Container: Container,
  RepeatableContainer: RepeatableContainer,
  RepeatableSection: RepeatableSection,

  // Content
  FormText: TextBlock,
  FormDividingLine: FormDividingLine,
  FormImage: ImageBlock,

  // Inputs
  FormTextInput: FormTextInput,
  FormMultipleTextInput: FormMultipleTextInput,
  FormNumberInput: FormNumberInput,
  FormSliderInput: FormSliderInput,
  FormDateInput: FormDateInput,
  FormDateRangeInput: FormDateRangeInput,
  FormTimeInput: FormTimeInput,
  FormRadioGroupInput: FormRadioGroupInput,
  FormDropdownInput: FormDropDownInput,
  FormCheckboxGroupInput: FormCheckboxGroupInput,
  FormMultipleDropdownInput: FormMultipleDropdownInput,
  FormTagInput: FormTagInput,
  FormFileInput: FormFileInput,
};
